import { render, staticRenderFns } from "./AssignConfigurableProductPopup.vue?vue&type=template&id=42fb12d1"
import script from "./AssignConfigurableProductPopup.vue?vue&type=script&lang=js"
export * from "./AssignConfigurableProductPopup.vue?vue&type=script&lang=js"
import style0 from "./AssignConfigurableProductPopup.vue?vue&type=style&index=0&id=42fb12d1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports